import axios from 'axios'
import errCodes from '@/events/errorCodes'
import cookie from 'js-cookie'

const auth = {
  state: {
    authStatus: {
      code: '',
      msg: ''
    }
  },
  mutations: {
    SET_AUTH_STATUS (state, code) {
      state.authStatus.code = code
      let codeArr = code.split('-')
      let codeStr = errCodes
      for (let i = 0; i < codeArr.length; i++) {
        codeStr = codeStr[codeArr[i]]
      }
      state.authStatus.msg = (code !== 200) ? codeStr : ''
    },
    REMOVE_AUTH_INFO (state) {
      cookie.remove('CT')
      cookie.remove('CTN')
      Object.keys(state.authStatus).forEach(item => {
        switch (typeof state.authStatus[item]) {
          case 'string':
            state.authStatus[item] = ''
            break
          case 'number':
            state.authStatus[item] = 0
            break
          case 'object':
            state.authStatus[item] = {}
            break
          default:
            if (Array.isArray(state.authStatus[item])) {
              state.authStatus[item] = []
            }
        }
      })
    },
    REMOVE_GOOGLE_DATA(state){
      cookie.remove('GT')
    }
  },
  actions: {
    doLogin ({commit}, {params}) {
      return new Promise((resolve, reject) => {
        axios.post('/auth/login', params)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },
    doAdminLogin ({commit}, {params}) {
      return new Promise((resolve, reject) => {
        axios.post('/auth/adminlogin', params)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },
    forgetPw ({commit}, {params}) {
      return new Promise((resolve, reject) => {
        axios.post('/auth/forgetPw', params)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },
    resetPw ({commit}, {params}) {
      return new Promise((resolve, reject) => {
        axios.post('/auth/resetPw', params)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },
    verifyResetCode ({commit}, {params}) {
      return new Promise((resolve, reject) => {
        axios.post('/auth/verifyResetCode', params)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },
    changePw ({commit}, {params}) {
      return new Promise((resolve, reject) => {
        axios.post('/api/v1/users/changePw', params)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    }
  },
  getters: {
    authStatus (state) {
      return state.authStatus
    }
  }
}

export default auth
